import dynamic from 'next/dynamic';
import { wfbAdsLoading as loading } from './WfbAdsLoader';

const DynamicWfbAds = dynamic(() => import(
  './WfbAds'
), {
  ssr: false,
  loading,
});

export default DynamicWfbAds;
